export const formatPostcode = (postcode: string) => {
  return postcode.split(/(?=.{3}$)/).join(' ')
}
